import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "py-3 px-6" }
const _hoisted_2 = { class: "space-y-6" }
const _hoisted_3 = { class: "" }
const _hoisted_4 = { class: "text-sm text-gray-900 whitespace-nowrap px-6 py-5" }
const _hoisted_5 = { class: "text-sm text-gray-900 whitespace-nowrap px-6 py-5" }
const _hoisted_6 = { class: "text-sm text-gray-900 whitespace-nowrap px-6 py-5 w-6/12" }
const _hoisted_7 = { class: "text-sm text-gray-900 whitespace-nowrap px-6 py-5" }
const _hoisted_8 = { class: "text-sm text-gray-900 whitespace-nowrap px-6 py-5" }

import AdminLayout from '@/layouts/AdminLayout.vue';
import FilterComponent from '@/components/FilterComponent.vue';
import DataTable from '@/components/DataTable.vue';
import DatePicker from '@/components/inputs/DatePicker.vue';
import PagePagination from '@/components/PagePagination.vue';
import PageLoader from "@/components/PageLoader.vue";
import http from '@/axios'

import { paginatePage } from '@/helpers/PageHelper';
import { onMounted, ref } from 'vue';

/**
 * ********************************
 * Data 
 * ********************************
 */

export default /*@__PURE__*/_defineComponent({
  __name: 'IndexPage',
  setup(__props) {

const loader      = ref(false);
const goToPage    = ref();
const filterDate   = ref(null);
const items       = ref(null);
const items_count = ref(null);

const headers: { text: string }[] = [
    { text: 'ID' },
    { text: 'Subject' },
    { text: 'Description' },
    { text: 'Caused By' },
    { text: 'Date Created'}
];

/**
 * ********************************
 * Methods
 * ********************************
 */

const applyFilters = () => {
    indexActivityLogs(goToPage.value)
}

 const indexActivityLogs = async (data: string) => {
    loader.value = true;
    
    try  {
        const dateQuery     = filterDate.value ? `&filterDate=${filterDate.value}` : '';
        const goToPageValue = paginatePage(data);

        const response = await http.get(`activity-logs/index?${goToPageValue}&${dateQuery}`)

        loader.value          = false;
        items.value           = response.data.items;
        items_count.value     = response.data.items_count

    }catch(error) {
        loader.value = false;
        
        if(error.response.status == 401) {
            window.location.replace('/login');
        }
    }
}

onMounted(() => indexActivityLogs(goToPage.value))


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AdminLayout, { title: "Activity Logs" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(FilterComponent, {
          "text-filters": false,
          "onUpdate:searchText": _cache[1] || (_cache[1] = (value) => (_ctx.searchText = value)),
          "onUpdate:filters": applyFilters,
          "custom-filters": _ctx.activeTab !== 'activity_logs'
        }, {
          fields: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(DatePicker, {
                id: "filterDate",
                name: "filterDate",
                range: "",
                is24: "",
                isPresetRanges: "",
                modelValue: filterDate.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filterDate).value = $event)),
                placeholder: "Start Date & End Date",
                label: "Start Date & End Date"
              }, null, 8, ["modelValue"])
            ])
          ]),
          _: 1
        }, 8, ["custom-filters"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(DataTable, {
          noAction: "",
          headers: headers,
          count: items.value?.data.length
        }, {
          body: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value?.data, (item, key) => {
              return (_openBlock(), _createElementBlock("tr", { key: key }, [
                _createElementVNode("td", _hoisted_4, [
                  _createElementVNode("p", null, _toDisplayString(item.id), 1)
                ]),
                _createElementVNode("td", _hoisted_5, _toDisplayString(item.event), 1),
                _createElementVNode("td", _hoisted_6, _toDisplayString(item.description), 1),
                _createElementVNode("td", _hoisted_7, _toDisplayString(item.causer_name), 1),
                _createElementVNode("td", _hoisted_8, _toDisplayString(item.created_at), 1)
              ]))
            }), 128))
          ]),
          _: 1
        }, 8, ["count"]),
        _createVNode(PagePagination, {
          class: "mb-6",
          items: items.value,
          onNextPage: indexActivityLogs
        }, null, 8, ["items"])
      ]),
      (loader.value)
        ? (_openBlock(), _createBlock(PageLoader, { key: 0 }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})